import { type VossErrorCode } from "./types";

// User-facing copy for typed conversation failures. Capability-level only — NEVER names a provider,
// runtime, model, endpoint, or infrastructure detail. (The real technical cause stays in server logs.)
export interface FailureCopy {
  readonly title: string;
  /** Optional recovery affordance. "retry" re-runs the turn; "new-chat" starts a fresh session. */
  readonly action?: "retry" | "new-chat";
}

export const FAILURE_COPY: Record<VossErrorCode, FailureCopy> = {
  TIMEOUT: { title: "VOSS didn’t finish that response in time.", action: "retry" },
  SERVICE_UNAVAILABLE: { title: "VOSS couldn’t reach the intelligence service.", action: "retry" },
  INSUFFICIENT_EVIDENCE: { title: "VOSS doesn’t have enough evidence in this workspace to answer that yet." },
  SESSION_EXPIRED: { title: "This conversation session has ended.", action: "new-chat" },
  UNKNOWN: { title: "Something interrupted that response.", action: "retry" },
};

export const failureCopy = (code: VossErrorCode): FailureCopy => FAILURE_COPY[code] ?? FAILURE_COPY.UNKNOWN;
